/**
 * Hero Circuit Design System - Shared Configuration
 * 
 * All case study hero circuits must use these values for consistency.
 * "Different systems, same discipline."
 * 
 * Updated for LIGHT THEME backgrounds
 */

export const circuitConfig = {
  // Colors - Optimized for light backgrounds
  colors: {
    node: {
      fill: '#1B2430',  // Dark fill for visibility on light bg
      stroke: 'rgba(15, 118, 110, 0.5)',
      coreStroke: 'rgba(15, 118, 110, 0.7)',
      coreFill: 'rgba(15, 118, 110, 0.15)',
      coreInner: '#0F766E',
    },
    line: {
      default: 'rgba(15, 118, 110, 0.25)',
      active: 'rgba(15, 118, 110, 0.5)',
    },
    pulse: {
      fill: '#0F766E',
    },
    text: {
      primary: '#1B2430',
      secondary: '#475569',
      muted: '#64748B',
      accent: '#0F766E',
    },
    glow: {
      ring: 'rgba(15, 118, 110, 0.12)',
    }
  },
  
  // Stroke widths
  stroke: {
    line: 0.6,
    node: 0.8,
    core: 1,
  },
  
  // Node sizes
  nodeSize: {
    small: 3,
    core: 6,
    coreInner: 2,
  },
  
  // Animation timing
  animation: {
    pulseDuration: '6s',
    glowDuration: '5s',
    fadeIn: 300,
  },
  
  // Container size
  size: {
    width: 240,
    height: 160,
  }
};

/**
 * Shared SVG Defs for all hero circuits
 */
export const CircuitDefs = () => (
  <defs>
    <filter id="heroGlow" x="-50%" y="-50%" width="200%" height="200%">
      <feGaussianBlur stdDeviation="1.2" result="coloredBlur"/>
      <feMerge>
        <feMergeNode in="coloredBlur"/>
        <feMergeNode in="SourceGraphic"/>
      </feMerge>
    </filter>
  </defs>
);

export default circuitConfig;
